var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SystemMaintenance.TaxControlDiskNumberMaintenance"),
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.onCancel
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "400px" },
            attrs: {
              "grid-options": _vm.clientNoDialog.gridOptions,
              "column-defs": _vm.clientNoDialog.columnDefs,
              "row-data": _vm.rowData || []
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          }),
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c("div", { staticClass: "filters" }),
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.addItem }
                  },
                  [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Add")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "mini",
                      type: "danger",
                      disabled: !_vm.clientNoDialog.selectedData
                    },
                    on: { click: _vm.removeItem }
                  },
                  [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")) + " ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onSave }
                  },
                  [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onCancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }